
import React from "react";
import Ticket from "./ticket/Ticket";
import Create from "./ticket/Create";
import Header from "../shared/Header";
import Footer from "../shared/Footer";
import Tickets from "./ticket/Tickets";
import { i18nManager } from "../../i18n";
import Breadcrumb from "../shared/Breadcrumb";
import * as ReactRouterDom from "react-router-dom";

function Support() {
    const labels = i18nManager.Labels.support;
    const [subTitle, setSubTitle] = React.useState<string>();
    const [title, setTitle] = React.useState<string>(labels.title);
    const [showBreadCrumb, setShowBreadCrumb] = React.useState<boolean>(true);
    const [onTokenRefreshed, setOnTokenRefreshed] = React.useState<() => void>();

    return (<div className="support">
        <Header title={title} subTitle={subTitle} onTokenRefreshed={onTokenRefreshed} authorized />
        {showBreadCrumb && <Breadcrumb breadCrumbs={[{ label: title, location: window.location.href }]} />}
        <ReactRouterDom.Routes>
            <ReactRouterDom.Route path="/create" element={<Create setTitle={setTitle} />} />
            <ReactRouterDom.Route path="/tickets" element={<Tickets setTitle={setTitle} setShowBreadCrumb={setShowBreadCrumb} />} />
            <ReactRouterDom.Route path="/ticket/:id" element={<Ticket setTitle={setTitle} setSubTitle={setSubTitle} setShowBreadCrumb={setShowBreadCrumb} setOnTokenRefreshed={setOnTokenRefreshed} />} />
        </ReactRouterDom.Routes>
        <Footer />
    </div>);

}

export default Support;
